import React from "react";
import "./DownloadLink.css";
import file from "../../../assets/file.png";
import { TrackGoogleAnalyticsEvent } from "../../../helpers/InitializeGoogleAnalytics";
import createGoogleAnalyticsTemplateName from "../../../helpers/createGoogleAnalyticsTemplateName";

const DownloadLink = ({ link, type, name }) => {
  // Here we set the link to be downloaded and the google analytics tracking
  function downloadTemplate() {
    window.open(link);
    TrackGoogleAnalyticsEvent(
      "click",
      `CTA DL ${type}: ${createGoogleAnalyticsTemplateName(name)}`,
      "click"
    );
  }

  return (
    <div className={"download-box"}>
      <p>{type}</p>

      <div>
        <img
          className="download-file"
          src={file}
          alt="file icon"
          onClick={downloadTemplate}
        />
        <span className={"download-link"} onClick={downloadTemplate}>
          Download(zip)
        </span>
      </div>
    </div>
  );
};

export default DownloadLink;
